import { isEmpty } from "lodash-es";
import { FormControl } from "@ecco/ui/form-control";
import { FormErrorMessage } from "@ecco/ui/form-error";
import { FormLabel } from "@ecco/ui/form-label";
import { Box } from "@ecco/ui/box";
import { styles } from "../baseFormStyles";
import type { SingleFieldProps } from "../baseFormsValidations";
import { getSalutation, getSalutationName } from "@components/commerce/baseForms/helpers/helpers";
import type { CountryCode } from "@config/site/types";
import type { SystemStyleObject } from "@ecco/ui/types";
import type { FormikHelpers } from "formik";
import { ResponsiveDropdownField } from "../ResponsiveDropdown/ResponsiveDropdownField";

export interface Salutation {
    name: string;
    value: string;
}

type regionFieldExtensions = {
    prefix: string;
    setFieldValue: FormikHelpers<unknown>["setFieldValue"];
    title: string;
    style?: SystemStyleObject;
    stateDropdownStyle?: object;
    country?: CountryCode;
    locale?: string;
    value: string;
};

interface SalutationFieldType extends SingleFieldProps, regionFieldExtensions {}

export const SalutationField = ({
    error,
    isInvalid,
    isSuccess,
    prefix,
    value,
    country,
    locale,
    title,
    header,
    setFieldValue,
    style,
    stateDropdownStyle,
    isReadOnly = false,
    testId,
}: SalutationFieldType) => {
    const salutations = getSalutation(locale);
    const fieldName = prefix + "salutation";
    if (!salutations.length) {
        return null;
    }

    return (
        <Box sx={style ?? styles.fieldsWrapper}>
            <FormControl
                isInvalid={isInvalid}
                isRequired
                isReadOnly={isReadOnly}
                isSuccess={isSuccess}
            >
                <FormLabel htmlFor={fieldName} sx={styles.formLabel}>
                    {header}
                </FormLabel>
                <ResponsiveDropdownField
                    country={country}
                    locale={locale}
                    setFieldValue={setFieldValue}
                    title={isEmpty(value) ? title : getSalutationName(value, locale)}
                    fieldName={fieldName}
                    isReadOnly={isReadOnly}
                    testId={testId}
                    error={error}
                    dropdownStyle={stateDropdownStyle}
                    items={salutations}
                />
                <FormErrorMessage>{error}</FormErrorMessage>
            </FormControl>
        </Box>
    );
};

export default SalutationField;
